import { NgModule } from "@angular/core";
import { InputErrorPipe } from "./input-error.pipe";
import { FilterBenefitsPipe } from "./motor-membership.pipe";

@NgModule({
	imports: [],
	declarations: [InputErrorPipe, FilterBenefitsPipe],
	exports: [InputErrorPipe, FilterBenefitsPipe],
})
export class CustomPipeModule {}
